import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { Angulartics2Module } from 'angulartics2';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SalesPartnersPageComponent } from './components/page/sales-partners-page.component';
import { SalesPartnersService } from './services/sales-partners.service';
import { SalesPartnersRoutingModule } from './sales-partners-routing.module';


@NgModule({
  declarations: [
	SalesPartnersPageComponent,
  ],
  providers: [
    SalesPartnersService
  ],
  imports: [
    CommonModule,
    SalesPartnersRoutingModule,
    MatButtonModule,
    SharedModule,
    NgOptimizedImage,
    Angulartics2Module,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
})
export class SalesPartnersModule { }
